
<template>
  <div class="wrap">
    <div class="page"></div>
    <van-dialog
      v-model="dialog.show"
      title=""
      :show-confirm-button="false"
    >
      <template v-if="type === 'OFFLINE'">
        <div class="dialog-msg">
          <p>
            <img src="@/assets/baibu/ic-warning.png" class="dialog-icon" alt="">
            {{ dialog.message }}
          </p>
          <div class="dialog-info" v-if="this.offlineInfo !== null">
            <p><span>订单编号：</span>{{ offlineInfo.orderCode}}</p>
            <p><span>应收金额：</span>{{ offlineInfo.payAmount}}</p>
            <p><span>收款账户：</span></p>
            <p class="dialog-bank-info">
              <span>账号：</span>{{ offlineInfo.bankCardNo}}<br />
              <span>户名：</span>{{ offlineInfo.bankCardAccountName}}<br />
              <span>银行：</span>{{ offlineInfo.bankName}}
            </p>
          </div>
          <div class="dialog-info" v-else>{{ dialog.tip }}</div>
        </div>
        <div class="dialog-wrap">
          <button
            v-if="this.offlineInfo !== null"
            class="btn btn-confirm btn-copy"
            @click="handleCopy"
            data-clipboard-action="copy"
            :data-clipboard-text="`账号：${offlineInfo.bankCardNo || ''}\n户名：${offlineInfo.bankCardAccountName || ''}\n银行：${offlineInfo.bankName || ''}`"
          >
            复制收款账户
          </button>
          <wx-open-launch-weapp
            id="launch-btn"
            username="gh_4132e10d162b"
            :path="weappPath"
            @error="handleErrorFn"
            @launch="handleLaunchFn"
          >
            <script type="text/wxtag-template">
              <style>.btn {
              color: #333;
              background: #fff;
              border: 1PX solid #333;
              min-width: 128PX;
              padding: 0 20PX;
              text-align: center;
              font-size: 14PX;
              height: 36PX;
              line-height: 36PX;
              border-radius: 36PX;
              outline: none;
              }</style>
              <button class="btn">
              返回订单详情
              <img
              style="width: 15px;vertical-align: middle;margin-left: 5px;"
              src="https://img.ibaibu.com/baibu_5de0f67969bb467a93cf0fa633f50de5.png"
              />
              </button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </template>
      <template v-else>
        <div class="dialog-msg">
          <img src="@/assets/baibu/ic-warning.png" class="dialog-icon" alt="">
          {{ dialog.message }}
        </div>
        <div class="dialog-wrap">
          <button
            class="btn btn-cancel"
            @click="dialog.show = false"
            v-if="dialog.isShowCancelBtn"
          >
            关闭
          </button>
          <button
            v-if="!dialog.isShowCancelBtn"
            class="btn btn-confirm"
          >
            打开收银台
            <img
              style="width: 15px;vertical-align: middle;margin-left: 5px;"
              src="https://img.ibaibu.com/baibu_5de0f67969bb467a93cf0fa633f50de5.png"
            />
          </button>
          <wx-open-launch-weapp
            v-if="dialog.isShowCancelBtn"
            id="launch-btn"
            username="gh_4132e10d162b"
            :path="weappPath"
            @error="handleErrorFn"
            @launch="handleLaunchFn"
          >
            <script type="text/wxtag-template">
              <style>.btn {
              min-width: 128PX;
              padding: 0 20PX;
              text-align: center;
              font-size: 14PX;
              color: #fff;
              height: 36PX;
              line-height: 36PX;
              border-radius: 36PX;
              background-image: linear-gradient(to right, #ff8f46, #f47248);
              border: 0;
              outline: none;
              }</style>
              <button class="btn">
              打开色卡仓小程序
              <img
              style="width: 15px;vertical-align: middle;margin-left: 5px;"
              src="https://img.ibaibu.com/baibu_5de0f67969bb467a93cf0fa633f50de5.png"
              />
              </button>
            </script>
          </wx-open-launch-weapp>
        </div>
        <div class="dialog-tip">{{ dialog.tip }}</div>
      </template>
    </van-dialog>
    <!--  mask  -->
    <div class="mask" id="iosMask">
      <img src="./images/ios_mask.png" alt="" style="width: 100%;">
    </div>
    <div class="mask" id="androidMask">
      <img src="./images/android_mask.png" alt="" style="width: 100%;">
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import {
  getSignature,
} from '@/api/base';
import {
  checkQrCodeContentUrl,
} from '@/api/baibu';
import Clipboard from 'clipboard';

let ifrTimer = null;
let timer = null;
// enum PaymentMethodEnum {
//   现结 = 'CASH',
//   城市垫付 = 'CREDIT',
//   金融 = 'LOAN',
//   司机收款 = 'DRIVER_COLLECTION',
//   车队代收 = 'TEAM_COLLECTION',
//   车队代付 = 'TEAM_PAYMENT',
//   货到付款 = 'CASH_ON_DRIVER',
//   BD货到收款 = 'LARGE_CREDIT',
//   // 招行收款码 = 'CMB_QRCODE',
//   // 易宝收款码 = 'YB_QRCODE',
//   百布钱包 = 'BAIBU_WALLET',
//   // CASH_ON_DELIVERY 该枚举是在金融垫付对接V1.0需求，财务那边新增的支付方式
// }

export default {
  name: 'LandingPagesElectronCodeSheetIndex',
  data() {
    return {
      type: '',
      offlineInfo: {
        bankCardAccountName: '',
        bankCardNo: '',
        payAmount: 0,
        orderCode: '',
        bankName: '',
      },
      dialog: {
        isShowCancelBtn: true,
        show: false,
        url: '',
      },
      // isShowAppBtn: false,
      weappPath: 'pages/home/index',
      orderId: '',
      localApp: 'bbpay://12345', // `baibu://bbpay${window.location.search}`;
      webLocation: 'https://apps.ibaibu.com/Android/BaiBu/production/app-release.apk',
      itunesLocation: 'https://itunes.apple.com/cn/app/bai-bu/id1116321003?mt=8',
    };
  },
  created() {
    document.title = '电子码单';
    this.orderId = this.$route.query.oId;
    this.checkQrCodeContentUrl();
  },
  mounted() {
    // this.getSignature();
    // this.handleOpenApp();
    // wx
    // wx.ready((res) => {
    //   console.log('wxres', res);
    //   /**
    //    * config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
    //    * config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，
    //    * 则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，
    //    * 则可以直接调用，不需要放在ready函数中
    //   */
    // });
    // wx.error((res) => {
    //   console.log('res', res);
    //   /**
    //    * config信息验证失败会执行error函数，如签名过期导致验证失败，
    //    * 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
    //    * 对于SPA可以在这里更新签名。
    //   */
    // });
  },
  methods: {
    // 复制
    handleCopy() {
      const clipboard = new Clipboard('.btn-copy');
      clipboard.on('success', () => {
        this.$toast.success('复制成功');
      });
      clipboard.on('error', () => {
        this.$toast.fail('复制失败');
      });
    },
    async checkQrCodeContentUrl() {
      try {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '数据加载中，请稍候...',
        });
        const {
          data: {
            errorMessage = '',
            url,
            offlineInfo,
            orderPoDetailStatus,
            type, // 为OFFLINE走这个线下支付流程
            // 码单状态
            // 待接单 = 'WAIT_ACCEPT',
            // 待核单 = 'WAIT_CHECK',
            // 待报单 = 'WAIT_APPLY',
            // 异常反馈 = 'ERROR',
            // 待确认报单 = 'WAIT_APPLY_CONFIRM',
            // 待开码单 = 'PO_WAIT_ACCEPT',
            // 待确认码单 = 'PO_WAIT_CHECK',
            // 待收款 = 'WAIT_COLLECTION',
            // 待付款 = 'WAIT_PAY',
            // 待发货 = 'WAIT_DELIVERY',
            // 已完结 = 'FINISH',
            // paymentMethodEnum, 货款方式
            orderCollectionStatus,
            // 主单收款状态
            // 待收款 = 'WAIT',
            // 收款中 = 'IN',
            // 部分收款 = 'PART',
            // 收款完成 = 'FINISH',
            // 已取消 = 'CANCEL',
          },
        } = await checkQrCodeContentUrl({
          orderId: this.orderId,
        }) || {};

        // '1' 订单详情
        // '2' 查看码单, 确认码单
        // '3' 立即支付 发起金融收银台

        this.dialog.show = true;

        if (errorMessage) {
          this.pageToOrderDetal(errorMessage);
          return;
        }

        if ([
          'FINISH',
          'CANCEL',
        ].includes(orderCollectionStatus)) {
          this.pageToOrderDetal(orderCollectionStatus === 'CANCEL'
            ? '该订单已取消' : '该订单已付款，无须重复支付，是否前往查看订单进度？');
          return;
        }

        if ([
          'WAIT_ACCEPT',
          'WAIT_OUT',
          'WAIT_CHECK',
        ].includes(orderPoDetailStatus)) {
          // 订单码单状态小于等于【待确认码单】且 state非【订单取消/订单终止】时
          // 指向色卡仓小程序_电子码单页面
          /* eslint-disable */
          this.weappPath = `subPage-order/detail/index?orderId=${this.orderId}&isNewOrder=YES&isAutoTriggerType=2`;
          this.dialog.isShowCancelBtn = true;
          this.dialog.message = '该订单码单未确认，是否前往操作';
          /* eslint-disable */
          this.getSignature();
          return;
        }

        /**
         * 订单收款状态小于【收款完成】
         * 且 state非【订单取消/订单终止】时，/
         * 默认指向金融收银台；
        */
        this.type = type;
        this.offlineInfo = offlineInfo;
       if (type !== 'OFFLINE') {
         if (url) {
          // 微信内，显示关闭按钮
          this.dialog.isShowCancelBtn = false;
          this.dialog.message = '码单已生效，正跳转至收银台';
          this.dialog.tip = '注：页面长时间没跳转，请人工点击跳转';
          this.dialog.url = url;
          setTimeout(() => {
            window.location.replace(url);
          }, 1500);
          return;
        }

        this.pageToOrderDetal('该订单已付款，无须重复支付，是否前往查看订单进度？');
       } else {
         // 线下
        if (['WAIT'].includes(orderCollectionStatus)) {
          this.type = type;
          this.offlineInfo = offlineInfo;
          this.pageToOrderDetal('码单已生效，请支付货款', false);
          return;
        }
        this.offlineInfo = null;
        this.dialog.tip = '请等待供应商确认查收货款，如有疑问请联系专属BD';
        this.pageToOrderDetal('订单已支付', false);
       }

      } catch (e) {
        console.log(e);
      } finally {
        this.$toast.clear();
      }
    },
    pageToOrderDetal (message, isNeedWebxin) {
      // state【订单取消/订单终止】
      // 色卡仓小程序_订单详情页；
      // 默认指向色卡仓小程序_订单详情页
      this.weappPath = `subPage-order/detail/index?orderId=${this.orderId}&isNewOrder=YES`;
      this.dialog.isShowCancelBtn = true;
      this.dialog.message = message;
      // 否则，指向色卡仓小程序_订单详情页；
      this.getSignature(isNeedWebxin);
    },
    async getSignature(isNeedWebxin = true) {
      if (!this.isWeiXin() && isNeedWebxin) {// 非微信，return
        this.dialog.message = '检测到当前环境不支持打开小程序，请使用微信扫描码单二维码';
        return;
      }

      try {
        const {
          data: {
            appId,
            timestamp,
            nonceStr,
            signature,
          },
        } = await getSignature({
          url: location.href.split('#')[0], // 'https://uat3-wapp.ibaibu.com/',
        });
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，
          // 若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // : 'wxe8749396faa9f5b0', // 必填，公众号的唯一标识
          timestamp, // : '1645523811699', // 必填，生成签名的时间戳
          nonceStr, // : 'tBufla3pcSBc1yD3lRocqEyeTnpGMKNA', // 必填，生成签名的随机串
          signature, // : '54659BD878455D9367AC5ABE15E8BDA39D8FFFDA', // 必填，签名
          jsApiList: [
            'onMenuShareTimeline',
            'wx-open-launch-weapp',
          ], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-weapp'],
        });
      } catch (e) {
        this.$toast.clear();
        console.log(e);
      }
    },
    handleErrorFn(e) {
      console.log('fail', e.detail);
    },
    handleLaunchFn(e) {
      console.log('success', e);
    },
    isZhiFuBao() {
      return navigator.userAgent.match(/AlipayClient/i)
        && navigator.userAgent.match(/AlipayClient/i)[0].toLowerCase() === 'alipayclient';
    },
    isWeiXin() {
      return navigator.userAgent.match(/MicroMessenger/i)
        && navigator.userAgent.match(/MicroMessenger/i)[0].toLowerCase() === 'micromessenger';
    },
    isQQWebView() {
      return navigator.userAgent.toLowerCase().match(/ qq\//i);
    },
    isWeiBo() {
      return navigator.userAgent.toLowerCase().match(/weibo/i);
    },
    isMobile() {
      return this.isAndroid() || this.isIOS();
    },
    isAndroid() {
      return navigator.userAgent.match('Android');
    },
    isIOS() {
      return (
        navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone')
      );
    },
    isSafari() {
      return this.isIOS() && navigator.userAgent.match(/Safari/);
    },
    isChrome() {
      return !!(
        navigator.userAgent.match(/Chrome/i) != null
        && navigator.userAgent.match(/Version\/\d+\.\d+(\.\d+)?\sChrome\//i) == null
      );
    },
    getSafariVersion() {
      // eslint-disable-next-line no-useless-escape
      return navigator.userAgent.match(/Version\/([\d\.]+)/);
    },
    isXiaoMi() {
      return navigator.userAgent.match('XiaoMi');
    },
    createIframe(url) {
      const ifr = document.createElement('iframe');
      ifr.setAttribute('src', url);
      ifr.setAttribute('style', 'display: none');
      document.body.appendChild(ifr);
      clearTimeout(ifrTimer);
      ifrTimer = window.setTimeout(() => {
        document.body.removeChild(ifr);
      }, 2000);
    },
    downloadApp(type) {
      let version = 0;
      const getVersion = this.getSafariVersion();

      if (getVersion) {
        version = parseFloat(getVersion[1], 10);
      }
      const {
        // localApp,
        webLocation,
        itunesLocation,
      } = this;
      let url = null;
      if (type === 'iOS') {
        // iOS
        url = itunesLocation;
      } else {
        url = webLocation;
      }
      if (this.isSafari() && version >= 9) {
        clearTimeout(timer);
        // 下载
        timer = setTimeout(
          () => {
            this.goToLocation(url);
          },
          this.isAndroid() ? 2000 : 1000,
        );
      } else {
        // 下载
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.createIframe(url);
        }, 2000);
      }
    },
    openApp() {
      // const {
      //   // localApp,
      //   webLocation,
      //   itunesLocation,
      // } = this;
      let version = 0;
      const getVersion = this.getSafariVersion();

      if (getVersion) {
        version = parseFloat(getVersion[1], 10);
      }

      // if (type === 'iOS') {
      //   // iOS
      //   url = itunesLocation;
      // } else {
      //   url = webLocation;
      // }

      document.addEventListener('visibilitychange', () => {
        clearTimeout(timer);
        clearTimeout(ifrTimer);
      });

      // Android 使用 iframe ios 使用 location 跳转
      if (this.isSafari() && version >= 9) {
        // 判断safari版本 如果大于9
        this.goToLocation('baibu://productDetail');

      } else {
        // Chrome 使用 iframe 跳转不了
        if (this.isChrome()) {
          this.goToLocation('bbpay://12345');
          // if (autoOpen) {
          //     setTimeout(function () {
          //         autoOpen = false;
          //         openAppBtn.click();
          //     }, 50);
          // } else {
          //     goToLocation(localApp);
          // }
        } else {
          this.createIframe('bbpay://12345');
        }
        // goToLocation(localApp);
        // setTimeout(function () {
        //     createIframe(localApp);
        //     goToLocation(localApp);
        // }, 500);
        // createIframe(localApp);
      }
    },
    goToLocation(location) {
      window.location = location;
    },
    handleOpenApp(type) {
      if (this.isWeiXin() || this.isQQWebView() || this.isWeiBo() || this.isZhiFuBao()) {
        if (this.isIOS()) {
          document
            .getElementById('iosMask')
            .setAttribute('style', 'display: block;');
        } else {
          document
            .getElementById('androidMask')
            .setAttribute('style', 'display: block;');
        }
        return;
      }
      let phone = null;

      if (this.isAndroid()) {
        phone = 'Android';
      } else if (this.isIOS()) {
        phone = 'iOS';
      } else {
        phone = '其他';
      }
      if (type === 2) {
        this.openApp(phone);
      } else {
        this.downloadApp(phone);
      }
    },
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  user-select: none;
}
body, html, .wrap {
  height: 100%;
}
.wrap {
  background-image: linear-gradient(to bottom , #EDEDED, #fff);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.page {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 640px;
  margin: 0 auto;
  background: url("./images/img_background.png") center no-repeat;
  background-size: contain;

}

.dialog-msg {
  position: relative;
  margin: 40PX auto 0;
  padding: 0 30PX 0 50PX;
  font-size: 20PX;
  line-height: 30PX;
}
.dialog-icon {
  position: absolute;
  left: 20PX;
  top: 2PX;
  width: 25PX;
  height: 25PX;
}
.dialog-tip {
  padding: 14PX 30PX;
  color: #f47248;
  font-size: 14PX;
  line-height: 20PX;
}
.dialog-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30PX 30PX 20PX;
}
.btn {
  display: block;
  min-width: 80PX;
  padding: 0 20PX;
  text-align: center;
  font-size: 14PX;
  color: #fff;
  height: 36PX;
  line-height: 36PX;
  border-radius: 36PX;
  border: 0;
  outline: none;
}
.btn-cancel {
  margin-right: 20PX;
  color: #333;
  background: #fff;
  border: 1PX solid #333;
}
.btn-confirm {
  background-image: linear-gradient(to right, #ff8f46, #f47248);
}
.mask {
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  /* background-color: rgba(0, 0, 0, 0.3); */
  width: 100%;
  /* height: 100%; */
}
.dialog-info {
  margin-top: 20PX;
  font-size: 12PX;
}
.dialog-bank-info {
  line-height: 20PX;
}
</style>
